import {
    ArrowRotateCwUpIcon as RotateCw,
    HeartIcon,
} from "@wags/ui/product-icons.tsx";

import { cn } from "@wags/ui/ui-utils";
import { iconButtonClass } from "@wags/ui/icon-button-class.ts";
import { useState } from "react";

export function FavoriteButtonFallback({
    variant = "overlay",
    className,
    onRetry,
}: {
    variant?: "overlay" | "icon";
    className?: string;
    onRetry?: () => Promise<void>;
}) {
    const [isRetrying, setIsRetrying] = useState(false);
    const canRetry = Boolean(onRetry) && !isRetrying;
    const label = canRetry
        ? "Couldn't load saved status. Retry"
        : "Loading saved status";

    return (
        <button
            type="button"
            aria-label={label}
            title={label}
            disabled={!canRetry}
            tabIndex={canRetry ? 0 : -1}
            data-favorite-state={canRetry ? "error" : "loading"}
            onClick={async (event) => {
                event.preventDefault();
                event.stopPropagation();
                if (!onRetry || isRetrying) return;
                setIsRetrying(true);
                try {
                    await onRetry();
                } catch {}
                setIsRetrying(false);
            }}
            className={cn(
                variant === "icon"
                    ? iconButtonClass
                    : "absolute top-2.5 right-2.5 z-10 flex size-10 items-center justify-center rounded-full bg-doberman-black/40 text-true-white backdrop-blur-sm shadow-[0_1px_4px_rgba(0,0,0,0.12)] after:absolute after:-inset-0.5 after:content-['']",
                canRetry &&
                    "cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-labrador-yellow",
                className,
            )}
        >
            {onRetry ? (
                <RotateCw className="size-4" aria-hidden="true" />
            ) : (
                <HeartIcon className="size-6" aria-hidden="true" />
            )}
        </button>
    );
}
